import { render, staticRenderFns } from "./FundUnmatched.vue?vue&type=template&id=d270429c"
import script from "./FundUnmatched.vue?vue&type=script&lang=js"
export * from "./FundUnmatched.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports